import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api_url } from "../../helpers/apiHelpers";
import { toast } from "react-toastify";
import { FormInput, WrapText } from "lucide-react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";

const ITExcel = () => {
  const route = useParams().id;
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("userName");
  const [ITCData, setITCData] = useState(null);

  useEffect(() => {
    const getITCData = async () => {
      const response = await fetch(`${api_url}/api/users/get-itc-data`, {
        method: "POST",
        body: JSON.stringify({
          userId,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();
      if (result.status === 201) {
        let data = result.users.find((item) => item._id === route);
        setITCData(data);
      }
    };
    getITCData();
  }, []);

  const [dMonthValues, setDMonthValues] = useState(null);
  const [calculatedValues, setCalculatedValues] = useState(null);
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [oldRegimeData, setOldRegimeData] = useState(null);
  const [newRegimeData, setNewRegimeData] = useState(null);

  useEffect(() => {
    // setEmployeeDetails(() => JSON.parse(ITCData.employeeDetails));
    // setDMonthValues(() => JSON.parse(ITCData.monthValues));
    // setCalculatedValues(() => JSON.parse(ITCData.calculatedValues));
    // setOldRegimeData(() => JSON.parse(ITCData.oldRegimeData));
    // setNewRegimeData(() => JSON.parse(ITCData.newRegimeData));

    try {
      if (ITCData?.employeeDetails) {
        setEmployeeDetails(JSON.parse(ITCData.employeeDetails));
      }
      if (ITCData?.monthValues) {
        setDMonthValues(JSON.parse(ITCData.monthValues));
      }
      if (ITCData?.calculatedValues) {
        setCalculatedValues(JSON.parse(ITCData.calculatedValues));
      }
      if (ITCData?.oldRegimeData) {
        setOldRegimeData(JSON.parse(ITCData.oldRegimeData));
      }
      if (ITCData?.newRegimeData) {
        setNewRegimeData(JSON.parse(ITCData.newRegimeData));
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
    }
  }, [ITCData]);

  const months = [
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Other",
  ];

  const columns = [
    "Basic",
    "DA",
    "HRA",
    "TA",
    "Fix TA",
    "WA",
    "CLA",
    "NPS",
    "Basic Arrs",
    "DA Arrs",
    "Total Pay",
    "GPF",
    "GPF Inst",
    "NPS",
    "DCPS",
    "PT",
    "GIS",
    "LIC",
    "I.Tax",
  ];

  const [monthValues, setMonthValues] = useState(
    months.reduce((acc, month) => {
      acc[month] = columns.reduce((colAcc, col) => {
        colAcc[col] = 0;
        return colAcc;
      }, {});
      return acc;
    }, {})
  );

  const [selectedMonths, setSelectedMonths] = useState(
    months.reduce((acc, month) => {
      acc[month] = false;
      return acc;
    }, {})
  );

  const FormSection = ({ title, children }) => (
    <div
      className={`bg-white border-gray-700 border-1 py-2 px-2   rounded-lg mb-3 `}
    >
      <h5 className="font-bold mb-3">{title}</h5>
      {children}
    </div>
  );

  const handleCalculatedValueChange = (field, value) => {};

  const FormInput = React.memo(
    ({ label, value, onChange, readOnly, disabled }) => {
      return (
        <div className="flex justify-between items-center mb-1">
          <label
            className={
              label === "Total Income" ||
              label === "Old Regime Tax" ||
              label === "New Regime Tax" ||
              label === "Tax Deducted From SALARY Rs." ||
              label === "Net Income Tax to Pay Rs." ||
              label === "Total Income Tax PAYABLE Rs."
                ? "fw-bold text-basic"
                : label === "Deduction U/s 80-C" ||
                  label === "Total Deduction U/S VI-A"
                ? "fw-bold text-sm"
                : "fw-bold text-sm"
            }
          >
            {label}{" "}
            {label === "Deduction U/s 80-C" ? (
              <small className="text-danger fw-bold">
                (limit upto 1.5 lacs)
              </small>
            ) : (
              ""
            )}
          </label>
          <label
            className={
              label === "Total Income"
                ? "fw-bold  px-2 text-right"
                : label === "Old Regime Tax" ||
                  label === "New Regime Tax" ||
                  label === "Tax Deducted From SALARY Rs." ||
                  label === "Net Income Tax to Pay Rs." ||
                  label === "Deduction U/s 80-C" ||
                  label === "Total Deduction U/S VI-A" ||
                  label === "Total Income Tax PAYABLE Rs."
                ? "fw-bold  px-2 text-right"
                : " fw-bold px-2 text-right"
            }
          >
            {value}
          </label>
        </div>
      );
    }
  );

  function getZoomLevel() {
    return window.devicePixelRatio || 1;
  }

  const calculateTotals = () => {
    return columns.map((column) =>
      months.reduce((total, month) => {
        // // Handle special column cases
        if (column === "Basic Arrs") {
          const value =
            parseFloat(dMonthValues && dMonthValues[month]?.["BasicArrs"]) || 0; // Default to 0 (number)
          return total + value;
        } else if (column === "DA Arrs") {
          const value =
            parseFloat(dMonthValues && dMonthValues[month]?.["DAArrs"]) || 0; // Default to 0 (number)
          return total + value;
        } else if (column === "Total Pay") {
          const value =
            parseFloat(dMonthValues && dMonthValues[month]?.["TotalPay"]) || 0; // Default to 0 (number)
          return total + value;
        } else if (column === "GPF Inst") {
          const value =
            parseFloat(dMonthValues && dMonthValues[month]?.["GPFInst"]) || 0; // Default to 0 (number)
          return total + value;
        } else {
          const value =
            parseFloat(dMonthValues && dMonthValues[month]?.[column]) || 0;
          return total + value;
        }
      }, 0)
    );
  };

  const getColumnValue = (month, column) => {
    // alert(column);
    // Check if the column name is one of the special columns
    if (column === "Basic Arrs") {
      return dMonthValues[month]?.["BasicArrs"] || "0"; // Default to "0" if value is not available
    }
    if (column === "DA Arrs") {
      return dMonthValues[month]?.["DAArrs"] || "0"; // Default to "0" if value is not available
    }
    if (column === "Total Pay") {
      return dMonthValues[month]?.["TotalPay"] || "0"; // Default to "0" if value is not available
    }

    if (column === "GPF Inst") {
      return dMonthValues[month]?.["GPFInst"] || "0"; // Default to "0" if value is not available
    }

    // Check if the column exists in the dMonthValues for the given month
    if (dMonthValues && dMonthValues[month]?.[column] !== undefined) {
      return dMonthValues[month][column];
    }

    // Default to "0" if no value is found
    return "0";
  };

  const exportToExcel = async () => {
    if (!employeeDetails) {
      alert("No employee details available.");
      return;
    }

    // Create a new workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Employee Report");

    // **Define common styles**
    const headerStyle = {
      font: { bold: true, color: { argb: "FFFFFF" } },
      fill: { type: "pattern", pattern: "solid", fgColor: { argb: "4F81BD" } },
      alignment: { horizontal: "center", vertical: "middle", wrapText: true },
      border: {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      },
      width: 100,
    };

    const cellBorder = {
      border: {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const titleStyle = {
      font: { bold: true, size: 14 },
      alignment: { horizontal: "center", vertical: "middle", wrapText: true },
    };
    const titleCellStyle = {
      font: { bold: true, size: 11 },
      alignment: { horizontal: "center", vertical: "middle", wrapText: true },
    };

    let rowIndex = 1; // Track row position

    // ✅ **1. Employee Basic Details**
    worksheet.addRow(["Employee Financial Report"]).font = {
      bold: true,
      size: 16,
    };
    rowIndex += 2;

    // employeeDetails &&
    //   Object.entries(employeeDetails).forEach(([key, value]) => {
    //     worksheet.addRow([key, value]);
    //     rowIndex++;
    //   });
    const employeeData = [
      [
        "Full Name",
        employeeDetails.EmpName || "-",
        "Financial Year",
        employeeDetails.financialYear || "-",
      ],
      [
        "Designation",
        employeeDetails.EmpDesignation || "-",
        "PAN No.",
        employeeDetails.PANNo || "-",
      ],
      [
        "Gender",
        employeeDetails.gender || "-",
        "Birth Date",
        employeeDetails.dateOfBirth || "-",
      ],
      [
        "Pay Scale",
        employeeDetails.payScale || "-",
        "Aadhar No.",
        employeeDetails.adharNo || "-",
      ],
    ];
    employeeData.forEach((row) => {
      worksheet.addRow(row).eachCell((cell) => Object.assign(cell, cellBorder));
    });

    rowIndex += 2; // Add space between sections

    // ✅ **2. Monthly Salary Data**
    const row = worksheet.addRow([
      "Monthly Statement Showing Pay & Allowances And Deduction Details",
      "TAN No.",
      employeeDetails?.officerTANNo,
    ]);

    // Apply font and alignment styles to all cells in the row
    row.eachCell((cell) => {
      cell.font = titleStyle.font; // Apply font style
      cell.alignment = titleStyle.alignment; // Apply text alignment and wrapText
    });

    // Merge cells A to C for the statement title
    // worksheet.mergeCells(`A${row.number}:B${row.number}`);

    rowIndex++;

    worksheet.addRow(["Month", ...columns]).eachCell((cell) => {
      Object.assign(cell, headerStyle);
    });

    months.forEach((month) => {
      const rowData = [
        month,
        ...columns.map((column) => getColumnValue(month, column)),
      ];
      worksheet
        .addRow(rowData)
        .eachCell((cell) => Object.assign(cell, cellBorder));
    });

    // Calculate totals for each column
    const totalRowData = [
      "Total",
      ...columns.map((column, index) => {
        return months.reduce(
          (sum, month) =>
            parseInt(sum) + parseInt(getColumnValue(month, column)),
          0
        );
      }),
    ];

    // Add total row to the worksheet
    worksheet.addRow(totalRowData).eachCell((cell) => {
      Object.assign(cell, cellBorder);
      cell.font = { bold: true }; // Make total row bold
    });

    rowIndex += months.length + 2; // Space between sections

    // ✅ **3. Income & Deductions**
    worksheet.addRow(["Income & Deductions"]).font = titleStyle.font;
    rowIndex++;

    const incomeDeductionHeaders = [
      "Income",
      "",
      "Deduction U/S 80-C",
      "",
      "Deduction U/S VI-A",
      "",
    ];
    worksheet.addRow(incomeDeductionHeaders).eachCell((cell) => {
      Object.assign(cell, headerStyle);
    });

    const incomeDeductionData = [
      [
        "Gross Salary",
        calculatedValues?.grossSalary,
        "GPF",
        calculatedValues?.gpf,
        "CCD 1B",
        calculatedValues?.ccd1b,
      ],
      [
        "Other Income",
        calculatedValues?.otherIncome,
        "DCPS",
        calculatedValues?.dcps,
        "NPS Employer Contribution",
        calculatedValues?.nps,
      ],
      [
        "Total Income",
        calculatedValues?.totalIncome,
        "GIS",
        calculatedValues?.gis,
        "Mediclaim Insurance",
        calculatedValues?.mediclaim,
      ],

      ["Deduction", "", "LIC", calculatedValues?.lic, "", ""],
      [
        "Old Regime Standard Deduction",
        "50000",
        "Tution Fees",
        calculatedValues?.tutionFees,
        "U/S 80DD Dependent Handicapped Person",
        calculatedValues?.dependentHandicapped,
      ],
      [
        "New Regime Standard Deduction",
        "75000",
        "NSC",
        calculatedValues?.nsc,
        "U/S 80E Interest on Educational Loan",
        calculatedValues?.educationLoanInterest,
      ],
      [
        "P.TAX",
        Math.round(calculatedValues?.ptax * 100) / 100,
        "PLI/RD",
        calculatedValues?.pliRd,
        "U/S 80EEB Electric Vehicle Loan",
        Math.round(calculatedValues?.electricVehicleLoan * 100) / 100,
      ],
      [
        "Home Loan",
        "",
        "Home Loan Principal",
        calculatedValues?.homeLoanPrincipal,
        "",
        "",
      ],
      [
        "Home Loan Interest",
        Math.round(calculatedValues?.homeLoanInterest * 100) / 100,
        "Mutual Fund",
        calculatedValues?.mutualFund,
        "U/S 80G Donation",
        Math.round(calculatedValues?.donation * 100) / 100,
      ],
      [
        "Home Loan Interest (Eligible)",
        Math.min(200000, parseInt(calculatedValues?.homeLoanInterest)),
        "Total Deduction U/s 80-C",
        calculatedValues?.totalDeduction80C,
        "U/S 80U Self Handicapped Person",
        Math.round(calculatedValues?.selfHandicapped * 100) / 100,
      ],
      [
        "HRA Rent",
        "",
        "Deduction U/s 80-C",
        Math.min(150000, calculatedValues?.totalDeduction80C),
        "",
        "",
      ],
      [
        "HRA Exemption",
        Math.round(calculatedValues?.hraExemption * 100) / 100,
        "Total Deduction U/S VI-A",
        Math.round(calculatedValues?.totalDeductionVIA * 100) / 100,
        "",
        "",
      ],
    ];

    incomeDeductionData.forEach((row) => {
      worksheet.addRow(row).eachCell((cell) => Object.assign(cell, cellBorder));
    });

    rowIndex += incomeDeductionData.length + 2;

    // ✅ **4. Tax Comparison Table**
    worksheet.addRow(["Old Regime vs. New Regime"]).font = titleStyle.font;
    rowIndex++;

    const taxComparisonHeaders = ["Old Regime", "", "New Regime", ""];
    worksheet.addRow(taxComparisonHeaders).eachCell((cell) => {
      Object.assign(cell, headerStyle);
    });

    const taxComparisonData = [
      [
        "Old Taxable Income",
        oldRegimeData?.old_regime_taxable_income,
        "New Taxable Income",
        newRegimeData?.new_regime_taxable_income,
        " I have Accepted",
        oldRegimeData?.total_it_payable < newRegimeData?.total_it_payable
          ? "Old Regime"
          : "New Regime",
      ],
      [
        "Old Tax",
        oldRegimeData?.old_regime_tax,
        "New Tax",
        newRegimeData?.new_regime_tax,
        "",
        "",
      ],
      [
        "Rebate Under 87A",
        oldRegimeData?.rebate,
        "Rebate Under 87A",
        newRegimeData?.rebate,
        "Total Income Tax to Pay",
        Math.min(
          oldRegimeData?.total_it_payable,
          newRegimeData?.total_it_payable
        ),
      ],
      [
        "Education Cess @ 4%",
        oldRegimeData?.education_cess,
        "Education Cess @ 4%",
        newRegimeData?.education_cess,
        "",
        "",
      ],
      [
        "Total Income Tax PAYABLE Rs.",
        oldRegimeData?.total_it_payable,
        "Total Income Tax PAYABLE Rs.",
        newRegimeData?.total_it_payable,
        "For the Financial Year",
        employeeDetails?.financialYear,
      ],
      [
        "Tax Deducted From SALARY Rs.",
        oldRegimeData?.deducted_salary,
        "Tax Deducted From SALARY Rs.",
        newRegimeData?.deducted_salary,
        "",
        "",
      ],
      [
        "Net Income Tax to Pay Rs.",
        oldRegimeData?.net_it_pay,
        "Net Income Tax to Pay Rs.",
        newRegimeData?.net_it_pay,
        "",
        "",
      ],
    ];

    taxComparisonData.forEach((row) => {
      worksheet.addRow(row).eachCell((cell) => Object.assign(cell, cellBorder));
    });

    rowIndex += taxComparisonData.length + 2;


    // ✅ **5. Certification Section**
    worksheet.addRow(["Certification Details"]).font = titleStyle.font;
    rowIndex++;
    let certificationRow = worksheet.addRow([
      `I Certify That information given by me is true & Correct for the Fin. Yr. ${employeeDetails?.financialYear}`,
      "",
      "The above given information found correct, Hence it is certified.",
      "",
    ]);

    certificationRow.eachCell((cell) => {
      cell.font = titleCellStyle.font; // Apply font style
      cell.alignment = titleCellStyle.alignment; // Apply text alignment and wrapText
    });

    const certificationData = [
      ["Signature", "", "Signature", ""],
      [
        "Name",
        employeeDetails?.EmpName,
        "Officer Name",
        employeeDetails?.officerDDOName,
      ],
      [
        "Designation",
        employeeDetails?.EmpDesignation,
        "Officer Designation",
        employeeDetails?.officerDDODesignation,
      ],
      [
        "Office Name",
        employeeDetails?.officeName,
        "Office Name",
        employeeDetails?.officeName,
      ],
    ];

    // Add rows to the worksheet
    certificationData.forEach((row, rowIndex) => {
      const addedRow = worksheet.addRow(row);

      // Apply text wrap only to the first row
      if (rowIndex === 0) {
        addedRow.eachCell((cell) => {
          cell.alignment = { wrapText: true, width: 100 };
        });
      }

      // Apply border styling to all rows
      addedRow.eachCell((cell) => {
        Object.assign(cell, cellBorder);
      });
    });

    rowIndex += certificationData.length + 2;

    // ✅ **Auto-adjust column widths**
    worksheet.columns.forEach((column) => {
      column.width = column.values.reduce(
        (max, val) => Math.max(max, val?.toString().length || 10),
        10
      );
    });

    // ✅ **Generate the Excel file**
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], { type: "application/octet-stream" }),
      "Employee_Report.xlsx"
    );
  };

  return (
    <div className="pb-5">
      <div
        className=" text-left"
        id="mainDiv"
        style={{
          width: "100%",
          marginTop: "10px",
          fontSize: 18,
        }}
      >
        <div style={{ paddingLeft: "50px", paddingRight: "10px" }}>
          <div class="table-responsive">
            <table class="IT-Excel_table table table-bordered">
              <thead>
                <tr>
                  <th colSpan={4} style={{ fontSize: 22, textAlign: "center" }}>
                    {employeeDetails && employeeDetails.officeName}, (
                    {employeeDetails && employeeDetails.officeAddress})
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Full Name</th>
                  <td>{employeeDetails && employeeDetails.EmpName}</td>
                  <th>Financial Year</th>
                  <td>
                    {(employeeDetails && employeeDetails.financialYear) || "-"}
                  </td>
                </tr>
                <tr>
                  <th>Designation</th>
                  <td>{employeeDetails && employeeDetails.EmpDesignation}</td>
                  <th>PAN No.</th>
                  <td>{(employeeDetails && employeeDetails.PANNo) || "-"}</td>
                </tr>
                <tr>
                  <th>Gender</th>
                  <td>{employeeDetails && employeeDetails.gender}</td>
                  <th>Birth Date</th>
                  <td>
                    {(employeeDetails && employeeDetails.dateOfBirth) || "-"}
                  </td>
                </tr>
                <tr>
                  <th>Pay Scale</th>
                  <td>{employeeDetails && employeeDetails.payScale}</td>
                  <th>Aadhar No.</th>
                  <td>{(employeeDetails && employeeDetails.adharNo) || "-"}</td>
                </tr>
                <tr>
                  <th colSpan={4}></th>
                </tr>
                <tr>
                  <th colSpan={3}>
                    Monthly Statement Showing Pay & Allowences And Deduction
                    Details
                  </th>
                  <th>
                    TAN No. : {employeeDetails && employeeDetails.officerTANNo}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="overflow-x-auto IT-Excel_table-main">
            <div className="min-w-[1000px]">
              <table className="w-100 border-collapse pt-0 mt-0">
                <thead>
                  <tr>
                    <th className="text-center pt-0 mt-0 sticky left-0 z-10 border border-gray-300 bg-gray-100 px-1">
                      Month
                    </th>
                    {columns.map((column, index) => (
                      <th
                        key={index}
                        className="text-center pt-0 mt-0 border border-gray-300 bg-gray-100 px-1"
                      >
                        {column}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {months.map((month, rowIndex) => (
                    <tr
                      key={rowIndex}
                      className={rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="fw-bold text-center pt-0 mt-0  sticky z-10 border border-gray-300 px-1 text-blue-500 bg-inherit">
                        <label className="text-center pt-0 mt-0 items-center space-x-2">
                          {month === "July" ? (
                            <span className="text-danger fw-bold">{month}</span>
                          ) : (
                            <span>{month}</span>
                          )}
                        </label>
                      </td>
                      {columns.map((column, colIndex) => (
                        <td
                          key={colIndex}
                          className="fw-bold text-center  border border-gray-300 px-1 pt-0 mt-0"
                        >
                          <label
                            type="text"
                            className={
                              column === "TotalPay"
                                ? "fw-bold text-purple-800 pt-0 mt-0 w-full bg-transparent outline-none text-center focus:ring-2 focus:ring-blue-300 rounded"
                                : column === "Basic"
                                ? "fw-bold pt-0 mt-0 w-full bg-transparent outline-none text-center focus:ring-2 focus:ring-blue-300 rounded"
                                : "w-full pt-0 mt-0 bg-transparent outline-none text-center focus:ring-2 focus:ring-blue-300 rounded"
                            }
                          >
                            {dMonthValues && getColumnValue(month, column)}
                          </label>
                        </td>
                      ))}
                    </tr>
                  ))}
                  <tr className=" bg-gray-100">
                    <td className="fw-bold sticky text-center z-10 border border-gray-300 px-1 pt-0 mt-0 text-black bg-gray-100">
                      Total
                    </td>
                    {calculateTotals().map((total, index) => (
                      <td
                        key={index}
                        className="fw-bold border border-gray-300 px-1 pt-0 mt-0 text-black text-center"
                      >
                        {Math.round(total)}{" "}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <table class="IT-Excel_table table table-bordered ">
            <tbody>
              <tr>
                <th colSpan="2">Income</th>
                <th colSpan="2">Deduction U/S 80-C</th>
                <th colSpan={2}>Deduction U/S VI-A</th>
              </tr>
              <tr>
                <td>Gross Salary</td>
                <td>{calculatedValues?.grossSalary}</td>
                <td>GPF</td>
                <td>
                  {Math.round(
                    parseInt(calculatedValues?.gpf) +
                      parseInt(calculatedValues?.gpfinst)
                  )}
                </td>
                <td>CCD 1B Additional Deduction to NPS</td>
                <td>{calculatedValues?.ccd1b}</td>
              </tr>
              <tr>
                <td>Other Income</td>
                <td>{Math.round(calculatedValues?.otherIncome * 100) / 100}</td>
                <td>DCPS</td>
                <td>{calculatedValues?.dcps}</td>
                <td>CCD 2 Employer contribution (NPS)</td>
                <td>{calculatedValues?.nps}</td>
              </tr>
              <tr>
                <td>Total Income</td>
                <td>{Math.round(calculatedValues?.totalIncome * 100) / 100}</td>
                <td>GIS</td>
                <td>{calculatedValues?.gis}</td>
                <td>U/S 80D Mediclaim Insurance</td>
                <td>{calculatedValues?.mediclaim}</td>
              </tr>
              <tr>
                <th colSpan="2">Deduction</th>
                <td>LIC</td>
                <td>{calculatedValues?.lic}</td>

                <th colSpan="2"></th>
              </tr>
              <tr>
                <td>Old Regime Standard Deduction</td>
                <td>50000</td>
                <td>Tution Fees</td>
                <td>{calculatedValues?.tutionFees}</td>
                <td>U/S 80DD Dependent Handicapped Person</td>
                <td>{calculatedValues?.dependentHandicapped}</td>
              </tr>
              <tr>
                <td>New Regime Standard Deduction</td>
                <td>75000</td>
                <td>NSC</td>
                <td>{calculatedValues?.nsc}</td>
                <td>U/S 80E Interest on Educational Loan</td>
                <td>{calculatedValues?.educationLoanInterest}</td>
              </tr>
              <tr>
                <td>P.TAX</td>
                <td>{Math.round(calculatedValues?.ptax * 100) / 100}</td>
                <td>PLI/RD</td>
                <td>{calculatedValues?.pliRd}</td>
                <td>U/S 80EEB Electric Vehicle Loan</td>
                <td>
                  {Math.round(calculatedValues?.electricVehicleLoan * 100) /
                    100}
                </td>
              </tr>
              <tr>
                <th colSpan="2">Home Loan</th>
                <td>Home Loan Principal</td>
                <td>{calculatedValues?.homeLoanPrincipal}</td>

                <th colSpan="2"></th>
              </tr>
              <tr>
                <td>Home Loan Interest</td>
                <td>
                  {Math.round(calculatedValues?.homeLoanInterest * 100) / 100}
                </td>
                <td>Mutual Fund</td>
                <td>{calculatedValues?.mutualFund}</td>
                <td>U/S 80G Donation</td>
                <td>{Math.round(calculatedValues?.donation * 100) / 100}</td>
              </tr>
              <tr>
                <td>Home Loan Interest (Eligible)</td>
                <td>
                  {Math.min(
                    200000,
                    parseInt(calculatedValues?.homeLoanInterest)
                  )}
                </td>
                <td>Total Deduction U/s 80-C</td>
                <td>{calculatedValues?.totalDeduction80C}</td>
                <td>U/S 80U Self Handicapped Person</td>
                <td>
                  {Math.round(calculatedValues?.selfHandicapped * 100) / 100}
                </td>
              </tr>
              <tr>
                <th colSpan={2}>HRA Rent</th>
                <td>
                  <strong>Deduction U/s 80-C</strong>
                </td>
                <td>{Math.min(150000, calculatedValues?.totalDeduction80C)}</td>
                <th colSpan={2}></th>
              </tr>
              <tr>
                <td>HRA Exemption</td>
                <td>
                  {Math.round(calculatedValues?.hraExemption * 100) / 100}
                </td>
                <td>Total Deduction U/S VI-A</td>
                <td>
                  {Math.round(calculatedValues?.totalDeductionVIA * 100) / 100}
                </td>
                <th colSpan={2}></th>
              </tr>
            </tbody>
          </table>
          <table class="IT-Excel_table table table-bordered ">
            <tbody>
              <tr>
                <th colSpan="2">Old Regime</th>
                <th colSpan="2">New Regime</th>
                <th colSpan="2"></th>
              </tr>
              <tr>
                <td>Old Taxable Income</td>
                <td>{oldRegimeData?.old_regime_taxable_income}</td>
                <td>New Taxable Income</td>
                <td>{newRegimeData?.new_regime_taxable_income}</td>
                <td
                  style={{
                    fontWeight: "bold",
                    fontSize: 20,
                    color: "red",
                  }}
                  rowSpan={2}
                >
                  I have Accepted
                </td>
                <td
                  style={{
                    fontWeight: "bold",
                    fontSize: 20,
                    color: "red",
                  }}
                  rowSpan={2}
                >
                  {oldRegimeData?.total_it_payable <
                  newRegimeData?.total_it_payable
                    ? "Old Regime"
                    : "New Regime"}
                </td>
              </tr>
              <tr>
                <td>Old Tax</td>
                <td>{oldRegimeData?.old_regime_tax}</td>
                <td>New Tax</td>
                <td>{newRegimeData?.new_regime_tax}</td>
              </tr>
              <tr>
                <td>Rebate Under Section 87A</td>
                <td>{oldRegimeData?.rebate}</td>
                <td>Rebate Under Section 87A</td>
                <td>{newRegimeData?.rebate}</td>
                <td
                  style={{
                    fontWeight: "bold",
                    fontSize: 20,
                    color: "red",
                  }}
                  rowSpan={2}
                >
                  Total Income Tax to Pay
                </td>
                <td
                  style={{
                    fontWeight: "bold",
                    fontSize: 20,
                    color: "red",
                  }}
                  rowSpan={2}
                >
                  {Math.min(
                    oldRegimeData && oldRegimeData.total_it_payable,
                    newRegimeData && newRegimeData.total_it_payable
                  )}
                </td>
              </tr>
              <tr>
                <td>Education Cess @ 4%</td>
                <td>{oldRegimeData?.education_cess}</td>
                <td>Education Cess @ 4%</td>
                <td>{newRegimeData?.education_cess}</td>
              </tr>
              <tr>
                <td>Total Income Tax PAYABLE Rs.</td>
                <td>{oldRegimeData?.total_it_payable}</td>
                <td>Total Income Tax PAYABLE Rs.</td>
                <td>{newRegimeData?.total_it_payable}</td>
                <td
                  style={{
                    fontWeight: "bold",
                    fontSize: 20,
                    color: "red",
                  }}
                  rowSpan={3}
                >
                  For the Financial Year
                </td>
                <td
                  style={{
                    fontWeight: "bold",
                    fontSize: 20,
                    color: "red",
                  }}
                  rowSpan={3}
                >
                  {" "}
                  {employeeDetails && employeeDetails.financialYear}
                </td>
              </tr>
              <tr>
                <td>Tax Deducted From SALARY Rs.</td>
                <td>{oldRegimeData?.deducted_salary}</td>
                <td>Tax Deducted From SALARY Rs.</td>
                <td>{newRegimeData?.deducted_salary}</td>
              </tr>
              <tr>
                <td>Net Income Tax to Pay Rs.</td>
                <td>{oldRegimeData?.net_it_pay}</td>
                <td>Net Income Tax to Pay Rs.</td>
                <td>{newRegimeData?.net_it_pay}</td>
              </tr>
            </tbody>
          </table>
          <table class="IT-Excel_table table table-bordered">
            <tbody>
              <tr>
                <td colspan="2" class="text-center fw-bold">
                  I Certify That information given by me is true & Correct for
                  the Fin. Yr. {employeeDetails?.financialYear}
                </td>
                <td></td>
                <th colspan="2" class="text-center fw-bold">
                  The above given information found correct, Hence it is
                  certified.
                </th>
              </tr>
              <tr>
                <td>Signature</td>
                <td>
                  <textarea
                    class="form-control bg-white"
                    readonly
                    rows="3"
                  ></textarea>
                </td>
                <td></td>
                <td>Signature</td>
                <td>
                  <textarea
                    class="form-control bg-white"
                    readonly
                    rows="3"
                  ></textarea>
                </td>
              </tr>
              <tr>
                <td>Name</td>
                <td>
                  <p class="fw-bold">{employeeDetails?.EmpName}</p>
                </td>
                <td></td>
                <td>Name</td>
                <td>
                  <p class="fw-bold">{employeeDetails?.officerDDOName}</p>
                </td>
              </tr>
              <tr>
                <td>Designation</td>
                <td>
                  <p class="fw-bold">{employeeDetails?.EmpDesignation}</p>
                </td>
                <td></td>
                <td>Designation</td>
                <td>
                  <p class="fw-bold">
                    {employeeDetails?.officerDDODesignation}
                  </p>
                </td>
              </tr>
              <tr>
                <td>Office Name</td>
                <td>{employeeDetails?.officeName}</td>
                <td></td>
                <td>Office Name</td>
                <td>{employeeDetails?.officeName}</td>
              </tr>
              <tr></tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-3">
        <div className="row">
          <div className="col-lg-3 m-auto text-center ">
            <button
              onClick={() => exportToExcel()}
              className="bg-blue-500 w-100 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              Excel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ITExcel;
